import React from 'react';
import ContractCard from './ContractCard';

const ContractsView = ({ contracts }) => {
  if (contracts.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-state-icon">📋</div>
        <div className="empty-state-text">Nessun contratto Rebelnet trovato</div>
        <div className="empty-state-hint">I nuovi dati appariranno qui in tempo reale</div>
      </div>
    );
  }

  return (
    <div className="contracts">
      {contracts.map(contract => (
        <ContractCard key={contract.id} contract={contract} />
      ))}
    </div>
  );
};

export default ContractsView;
